

import React, {Component} from 'react';
import { Redirect  } from "react-router-dom";


class ModalHotelDetails extends Component {

    state = {
        redirect : null
    }


    componentDidMount = () => {
        /*
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });
        console.log('ModalHotelDetails componentDidMount props', this.props);
        */
       let htmlElement = document.getElementsByTagName('html')[0];
       let bodyElement = document.getElementsByTagName('body')[0];
       bodyElement.className = "body_modal_open";
       htmlElement.className = "body_modal_open";
    }

    setModalHotelDisplayClosed = () => {
        let htmlElement = document.getElementsByTagName('html')[0];
        let bodyElement = document.getElementsByTagName('body')[0];
        bodyElement.className = "";
        htmlElement.className = "";

        this.props.setModalHotelDisplayClosed();

        //this.setState({ redirect: "/hotels/" }); 
    }
    
    
    
  render() { 


    const { hotel, facilities } =  this.props; 
    let hotelDetails = <div></div>

    const facilitiesList = facilities.map((f) =>
        <div  
          key={f.key} >
              <span>*</span>
              <span>&nbsp;</span>
              <span>{f.FacilityDesc}</span>
          </div>
    );


    if (typeof hotel != undefined && typeof hotel.HotelName  !== undefined ){
        hotelDetails = (
             
            <div className="cntered-flex">
                <div className="modal_main_bg2" ></div>
                <div className="cntered-flex">
                    <div className="modal_hotel_bg_2">

                      

                        <div className="modal_hotel_inner_bg">
                        
                                <div className="modal_hotel_top">  
                                    <div className="close_arrow pointer zindex1000" onClick={this.setModalHotelDisplayClosed}></div> 
                                    <div className="cntered-flex">
                                        <div className="modal_order_title1"> 
                                            {hotel.HotelName}
                                        </div>
                                    </div>
                                </div>


                                <div className="cntered-flex_alightTop hotels_details_paddingLeft40">
                                    <div className="hotel_details_item_left_col">
                                        <div className="hotel_details_item_left_part_container">


                                            <div className="hotel_details_item_left_part_section hotel_details_add_for_mobile">  
                                                <div className="hotel_details_mobile_big_img">
                                                    <img src={this.props.hotel.HotelPic1}  alt=""/>
                                                </div>
                                            </div>


                                            <div className="hotel_details_item_left_part_section">
                                                <div className="hotel_details_rigth_title_padding">
                                                    <span className="filter_container_title1">פרטי התקשרות</span>
                                                </div>

                                                {(hotel.HotelPhone != '') ?
                                                <div>
                                                    <span> {hotel.HotelPhone}</span>
                                                    <img src={"/images/site/telephone.png"} alt="" />
                                                </div>
                                                : null}

                                                {(hotel.HotelAddress != '') ?
                                                <div>
                                                    <span> {hotel.HotelAddress}</span>
                                                    <img src={"/images/site/map.png"}  alt="" />
                                                </div>
                                                : null}

                                                {(hotel.HotelEmail != '') ?
                                                <div>
                                                    <span> 
                                                        <a href={'mailto:' + hotel.HotelEmail}>
                                                            {hotel.HotelEmail}
                                                        </a>
                                                    </span>
                                                    <img src={"/images/site/mail.png"} alt="" />
                                                </div>
                                                : null}

                                                {(hotel.HotelWebsiteUrl != '') ?
                                                <div>
                                                    <span> 
                                                    <a href={hotel.HotelWebsiteUrl}  target="_blank">
                                                            {hotel.HotelWebsiteUrl}
                                                        </a>
                                                    </span>
                                                    <img src={"/images/site/website.png"} alt="" />
                                                </div>
                                                : null}
                                            </div>

                                            <div className="hp_search_pad1_line hotel_details_marginTop40"></div>

                                            <div className="hotel_details_item_left_part_section directionRtl">
                                                <div className="hotel_details_rigth_title_padding">
                                                    <span className="hotel_details_title1">רשימת מתקנים ופרטים נוספים </span>
                                                </div>
                                                {facilitiesList}
                                            </div>



                                            <div className="hotel_details_item_left_part_section hotel_details_add_for_mobile">
                                                <div className="hotel_details_rigth_title_padding">
                                                    <span className="hotel_details_title1">מתקני מלון</span>
                                                </div>



                                                <div className="hotel_details_facilities_container">

                                                    <div className="hotel_details_facility"> 
                                                        <div className="directionRtl facilityTitleFont">
                                                            בסיס אירוח
                                                        </div>
                                                        
                                                        <div className="directionRtl facilityDescFont">
                                                        {hotel.HostBase}
                                                        </div>
                                                    </div>

                                                    <div className="hotel_details_facility"> 
                                                        <img src={"/images/site/wifi.png"} alt="" />
                                                        <div>WiFi</div>
                                                    </div>

                                                    <div className="hotel_details_facility"> 
                                                        <img src={"/images/site/pool.png"} alt="" />
                                                        <div>בריכה</div>
                                                    </div>
                                                    <div className="hotel_details_facility">
                                                        <img src={"/images/site/spa.png"} alt="" />
                                                        <div>ספא</div>
                                                    </div>

                                                    {(hotel.HasParking == 1) ?
                                                    <div className="hotel_details_facility"> 
                                                        <img src={"/images/site/parking.png"} alt="" />
                                                        <div>חניה</div>
                                                    </div>
                                                     : null}


                                                </div>
                                            </div>



                                            
                                            
                                        </div>
                                    </div>

                                    
                                    <div className="hotel_details_item_right_col">
                                        <div className="hotel_details_item_rigth_part_container">

                                            <div className="hotel_details_big_img">
                                                <img src={hotel.HotelPic1}  alt=""/>
                                            </div>
                                            <div className="hotel_details_small_img_container">
                                                <div className="hotel_details_small_img">
                                                    <img src={hotel.HotelPic1}  alt=""/>
                                                </div>
                                                <div className="hotel_details_small_img marginLeft12">
                                                    <img src={hotel.HotelPic2}  alt=""/>
                                                </div>
                                                <div className="hotel_details_small_img marginLeft12">
                                                    <img src={hotel.HotelPic3}  alt=""/>
                                                </div>

                                                <div className="hotel_details_small_img marginLeft12">
                                                    <img src={hotel.HotelPic4}  alt=""/>
                                                </div>
                                            </div>


                                            <div className="textAlignRight">
                                                <div className="hotel_details_rigth_title_padding">
                                                    <span className="hotel_details_title1">מידע כללי</span>
                                                </div>
                                                <div className="hotel_details_content">
                                                    {hotel.HotelAbout}
                                                </div>

                                                <div className="hp_search_pad1_line hotel_details_marginTop40" ></div>

                                                <div className="hotel_details_rigth_title_padding">
                                                    <span className="hotel_details_title1"> מתקני מלון</span>
                                                </div>

                                                <div className="hotel_details_facilities_container">



                                                    <div className="hotel_details_facility"> 
                                                        <div className="directionRtl facilityTitleFont">
                                                            בסיס אירוח
                                                        </div>
                                                        
                                                        <div className="directionRtl facilityDescFont">
                                                        {hotel.HostBase}
                                                        </div>
                                                    </div>

                                                    <div className="hotel_details_facility"> 
                                                        <img src={"/images/site/wifi.png"} alt="" />
                                                        <div>WiFi</div>
                                                    </div>

                                                    {(hotel.HasPool > 0) ?
                                                    <div className="hotel_details_facility"> 
                                                        <img src={"/images/site/pool.png"} alt="" />
                                                        <div>בריכה</div>
                                                    </div>
                                                    : null}

                                                    {(hotel.HasSpa > 0) ?
                                                    <div className="hotel_details_facility">
                                                        <img src={"/images/site/spa.png"} alt="" />
                                                        <div>ספא</div>
                                                    </div>
                                                    : null}

                                                    {(hotel.HasParking == 1) ?
                                                    <div className="hotel_details_facility"> 
                                                        <img src={"/images/site/parking.png"} alt="" />
                                                        <div>חניה</div>
                                                    </div>
                                                    : null}
                                                </div>
                                            </div>
                                            

                                        </div>
                                    </div>
                                </div>

                        </div>
                    </div>
                </div>                
            </div>
        )
    }
            
    
    return (
        <React.Fragment >
            {hotelDetails}
        </React.Fragment>
    )
  }

} //component

export default ModalHotelDetails;
